<template>
<div>

  <breadcrumb></breadcrumb>

  <div class="row">
    <div class="col">
      <form v-on:submit.prevent="save">
        <div class="form-group">
          <label for="indiceSigla">Cor Fixa</label>
          <select v-model="form.indiceSigla" name="indiceSigla" id="indiceSigla" class="form-control form-control-sm">
            <option value="">Automático</option>
            <option value="REDHARD700">VERMELHO</option>
            <option value="YELLOW400">AMARELO</option>
            <option value="GREEN700">VERDE</option>
          </select>
        </div>

        <div class="form-group">
          <label for="nome">Nome</label>
          <input v-model="form.nome" type="text" class="form-control" id="nome" placeholder="Nome">
        </div>

        <div class="form-group">
          <label for="unidade">Unidade</label>
          <input v-model="form.unidade" type="number" step="0.01" class="form-control" id="unidade" placeholder="Unidade">
        </div>

        <div class="form-group">
          <label for="medida">Medida</label>
          <select v-model="form.medida" name="medida" id="medida" class="form-control form-control-sm">
            <option value="À vontade">À vontade</option>
            <option value="Barra">Barra</option>
            <option value="Bife">Bife</option>
            <option value="Bola">Bola</option>
            <option value="Caneca 500ml">Caneca 500ml</option>
            <option value="Cápsula">Cápsula</option>
            <option value="Colher de chá">Colher de chá</option>
            <option value="Colher de sopa">Colher de sopa</option>
            <option value="Concha">Concha</option>
            <option value="Copo">Copo</option>
            <option value="Colher de café">Colher de café</option>
            <option value="Colher de sobremesa">Colher de sobremesa</option>
            <option value="Copo 130g">Copo 130g</option>
            <option value="Copo 200ml">Copo 200ml</option>
            <option value="Copo 250ml">Copo 250ml</option>
            <option value="Dente">Dente</option>
            <option value="Dose">Dose</option>
            <option value="Espiga">Espiga</option>
            <option value="Fatia">Fatia</option>
            <option value="Filé">Filé</option>
            <option value="Fio de azeite">Fio de azeite</option>
            <option value="Folha">Folha</option>
            <option value="Garfada">Garfada</option>
            <option value="Garrafa">Garrafa</option>
            <option value="Garrafinha">Garrafinha</option>
            <option value="Gota">Gota</option>
            <option value="Gramas">Gramas</option>
            <option value="Lata">Lata</option>
            <option value="ml">ml</option>
            <option value="mg">mg</option>
            <option value="Pitada">Pitada</option>
            <option value="Palito">Palito</option>
            <option value="Passada de faca">Passada de faca</option>
            <option value="Pedaço Pequeno">Pedaço Pequeno</option>
            <option value="Pedaço">Pedaço</option>
            <option value="Pegador">Pegador</option>
            <option value="Porção">Porção</option>
            <option value="Potinho">Potinho</option>
            <option value="Punhado">Punhado</option>
            <option value="Quadradinho">Quadradinho</option>
            <option value="Rodela">Rodela</option>
            <option value="Unidade">Unidade</option>
            <option value="Unidade média">Unidade média</option>
            <option value="Unidade pequena">Unidade pequena</option>
            <option value="Sachê/Medida">Sachê/Medida</option>
            <option value="Scoop">Scoop</option>
            <option value="Taça">Taça</option>
            <option value="Tira">Tira</option>
            <option value="Tulipa">Tulipa</option>
            <option value="Xicara">Xicara</option>
          </select>
        </div>

        <div class="form-group">
          <label for="c">Carboidratos</label>
          <input v-model="form.c" type="number" step="0.01" class="form-control" id="c" placeholder="c">
        </div>

        <div class="form-group">
          <label for="p">Proteinas</label>
          <input v-model="form.p" type="number" step="0.01" class="form-control" id="p" placeholder="p">
        </div>

        <div class="form-group">
          <label for="g">Gordura</label>
          <input v-model="form.g" type="number" step="0.01" class="form-control" id="g" placeholder="g">
        </div>

        <div class="form-group">
          <label for="f">Fibras</label>
          <input v-model="form.f" type="number" step="0.01" class="form-control" id="f" placeholder="f">
        </div>

        <div class="form-group">
          <label for="gs">Gordura Saturada</label>
          <input v-model="form.gs" type="number" step="0.01" class="form-control" id="gs" placeholder="gs">
        </div>

        <div class="form-group">
          <label for="na">Sódio</label>
          <input v-model="form.na" type="number" step="0.01" class="form-control" id="na" placeholder="f">
        </div>

        <div class="form-group">
          <label for="kcal">Calorias</label>
          <input disabled v-model="form.kcal" type="number" step="0.01" class="form-control" id="kcal" placeholder="kcal">
        </div>

        <div class="form-group">
          <label for="cota">Cota Sugestão: {{getCota(form)}}</label>
          <input v-model="form.cota" type="number" step="0.01" class="form-control" id="cota" placeholder="Cota">
        </div>

        <div class="form-group">
          <router-link to="/alimento" class="btn btn-danger">Cancelar</router-link>
          <button :disabled="!form._id" class="btn btn-primary float-right">Atualizar</button>
        </div>

        <div class="alert alert-success alert-dismissible" role="alert" v-show="hasSuccess">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Fechar</span>
          </button>
          Alimento atualizado!
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" v-show="hasError">
          <button type="button" class="close" data-dismiss="alert" aria-label="fechar">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Fechar</span>
          </button>
          Erro, tente novamento.
        </div>

      </form>
    </div>
  </div>

</div>
</template>

<script>
import ls from 'local-storage';

export default {
  name: 'AlimentoEdit',
  data() {
    return {
      api: '',
      token: '',
      hasSuccess: false,
      hasError: false,
      form: {
        nome: '',
        unidade: '',
        medida: 0,
        cota: 0,
        kcal: 0,
        c: 0,
        p: 0,
        g: 0,
        f: 0,
        gs: 0,
        na: 0,
        indiceSigla: '',
      }
    };
  },
  methods: {
    save() {
      this.$http.put('v1/alimento', this.form).then(response => {
        if (response.data.success) {
          this.hasSuccess = true;
          this.$router.push('/alimento');
        } else {
          this.hasError = true;
        }
      });
    },
    getCota(alimento) {
      alimento.kcal = (alimento.c * 4) + (alimento.p * 4) + (alimento.g * 9);
      this.form.kcal = alimento.kcal;
      const e1 = (alimento.kcal / 40);
      const e2 = (alimento.c - alimento.p);
      const e3 = (alimento.gs / alimento.g) || 0;

      const formula = e1 + 0.05 * e2 + e3;
      let round = Math.ceil(formula);
      if (round - formula > 0.5) {
        round -= 1;
      }

      return round;
    }
  },
  beforeMount() {
    this.api = process.env.API_ENV;
    this.token = ls('token');
    this.$http.get('/v1/alimento/' + this.$route.params.id).then(response => {
      if (response.data) this.form = response.data;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/alimento/AlimentoEdit.vue